<template>
  <section class="page-container grid-container" v-if="!error && loaded">
    <div class="grid-container">
      
        <section>    
        <div class="grid-x grid-margin-x">
            <div class="cell small-12">
                <a @click="router.back()">← Back</a>
            </div>
        </div>
        </section>

        <section>
            <div class="grid-x grid-margin-x">
                <div class="cell small-12">
                    <h1 class="text-2xl font-bold">Pre-Engagement Questionnaire</h1>
                    <p>Thank you for completing your pre-engagement questionnaire, it is currently being reviewed by our team.</p>
                    <p>Below is a summary of the answers that you provided.</p>
                    <table>
                    <thead>
                        <tr>
                        <th>Answers Summary</th>
                        <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>                            
                            <td>Current Payroll Software Provider</td>
                            <td>{{ discoveryChecklist.currentPayrollSoftwareProvider }}</td>
                        </tr>
                        <tr>                            
                            <td>Accounting Software</td>
                            <td>{{ discoveryChecklist.accountingIntegration.softwareProvider }}</td>
                        </tr>
                        <tr>                            
                            <td>Banking Integration</td>
                            <td>{{ splitByCapitals(discoveryChecklist.banking.bankingExportType) }}</td>
                        </tr>
                        <tr>                            
                            <td>Auto Enrolment Pensions</td>
                            <td>{{ formatToYesNo(discoveryChecklist.hasAePension) }}</td>
                        </tr>
                        <tr>                            
                            <td>Occupational Pensions</td>
                            <td>{{ formatToYesNo(discoveryChecklist.hasNonAePensions) }}</td>
                        </tr>
                        <tr>                            
                            <td>Additional Reports Required</td>
                            <td>{{ formatToYesNo(discoveryChecklist.requiresAdditionalReports) }}</td>
                        </tr>
                        <tr>                            
                            <td>Bespoke Payments or Deductions</td>
                            <td>{{ formatToYesNo(discoveryChecklist.requiresOwnAdditionDeductions) }}</td>
                        </tr>
                        <tr>                            
                            <td>Resource Costing Required</td>
                            <td>{{ formatToYesNo(discoveryChecklist.requiresResourceCosting) }}</td>
                        </tr>
                        <tr>                            
                            <td>Custom Timesheet Required</td>
                            <td>{{ formatToYesNo(discoveryChecklist.hasOwnTimesheetFormat) }}</td>
                        </tr>
                        <tr>                            
                            <td>Foreign Tax Schemes</td>
                            <td>{{ formatToYesNo(discoveryChecklist.hasForeignTaxSchemes) }}</td>
                        </tr>

                        <tr>                            
                            <td>Construction Industry Scheme</td>
                            <td>{{ formatToYesNo(discoveryChecklist.hasCisSubContractors) }}</td>
                        </tr>

                        <tr>                            
                            <td>Off Payroll Workers (IR35)</td>
                            <td>{{ formatToYesNo(discoveryChecklist.hasOffPayrollWorkers) }}</td>
                        </tr>

                        <tr>                            
                            <td>TRONC System in Operation</td>
                            <td>{{ formatToYesNo(discoveryChecklist.hasTroncSystem) }}</td>
                        </tr>

                        <tr>                            
                            <td>Payrolling Benefits</td>
                            <td>{{ formatToYesNo(discoveryChecklist.hasPayrolledBenefits) }}</td>
                        </tr>

                        <tr>                            
                            <td>Non-Standard Requirements Identified</td>
                            <td>{{ formatToYesNo(discoveryChecklist.hasNonStandardRequirements) }}</td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <div class="cell small-12">
                    <button class="btn btn-secondary" @click="router.push({ name: 'Home' })">
                        Return to Home
                    </button>
                </div>
            </div>
            
        </section>
        

</div>

  </section>
<div style="clear: both; height: 1rem;"></div>

</template>

<script setup>

import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import { splitByCapitals } from '@/helpers/strings';
import { formatToYesNo } from '@/helpers/boolean';

const route = useRoute();
const router  = useRouter()
const taskId = route.params.taskId;
const discoveryChecklist = ref(null);
const loaded = ref(false);
const error = ref(null);

import { getPreDiscoveryChecklist } from '@/services/implementationmanagement.api';
onMounted(async () => {

  var response = await getPreDiscoveryChecklist(taskId);
  if(response.status !== 200 || response.data === null || response.data === undefined) {
    error.value = 'An error has occurred. Please contact your Qtac account manager.';
    return;
  }

  discoveryChecklist.value = JSON.parse(response.data.preDiscoveryChecklistJson);


  loaded.value = true;
});



</script>

